import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import 'ag-grid-enterprise';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import "./Library.css";
import { TopBar } from "../../shared/topBar/TopBar";
import { UrlPath } from "../../../config/routeConfig";
import {SBADropDown,SBAMultiSelect,SBAComboBox,SBAMultiSelectCheck,SBAMultiColumnComboBox,} from "../../UiComponents/SBADropDown";
import { SBAEditor } from '../../UiComponents/SBAEditor';
import { AgGridReact } from 'ag-grid-react';
import { sbaAxios } from "../../utils/sbaAxios";
import { getCategory, getActivityEntityType, getActivityType, } from "../../actions/investmentAction";
import { useDispatch, useSelector } from "react-redux";
import { getManagerContacts } from "../../actions/CommonAction";
import { getSubStrategy } from "../../actions/assetDetailsActions";
import { getPortfolioListAction } from '../../actions/portfolioListAction'
import { getAllUsers } from "../../actions/UserAction";
import { getAssetLists } from "../../actions/assetListAction";
import { insertOrUpdateActivityDetails, insertOrUpdateActivityDocument } from "../../../config/apiConfig";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import { SBNotify } from "../../utils/sbNotify";
import moment from "moment";
import { SBATextBox } from "../../UiComponents/SBATextBox";
import { getAssetNotesTabDetails } from "../../actions/assetNotestabAction";
import { getAssetDocuments } from "../../actions/assetDocumentsActions";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { useParams, useLocation } from "react-router-dom";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
export const InvestmentAddView=()=>{
    const Level = [
        { BreadCrumb: "Investment >", Routes: `${UrlPath.DocumentsInvestment}` },
    ];
return <>
    <div>
      <TopBar label={"Investment Add"} />
      <BreadCrumbs Levels={Level} />
      </div>
      <InvestmentAdd/>
</>
}
export const InvestmentAdd = ({Modal,selectedAsset,SelectedActivity,SelectedCategory,setDrawerSet,ActivityDisable,afterSave,ShowDocuments}) => {
    const dispatch = useDispatch();
    const history = useNavigate(); 
    const locationData = useLocation();   
    const Gstate = useSelector((state) => state) || {};
    const users = useSelector((state) => state.Users.Users);
    const AssetListDDL = Gstate.assetList.assetList || [];
    const Categoryfilter = useSelector((state) => state.Category.Category) || [];
    const Category = Categoryfilter.filter(item => item.ActivitySubTypeId !== -1)
    const [comments, setcomments] = useState();
    const [htmlcomments, sethtmlcomments] = useState();
    const getPortfolioList = useSelector(state => state?.portfolioList?.portfolioList)||[];
    const  ActivityTypefilter= useSelector((state) => state.ActivityType.ActivityType) || [];
    const ActivityType = ActivityTypefilter.filter(item => item.ActivityType !=="All")
    const Strategy = Gstate.subStrategy.subStrategy;
    const SubStrategy = Strategy?.filter(item => item.ClassificationValue !== "--Please Select--")
    const managerFillter = Gstate.managerContacts.managerContacts;
    const manager = managerFillter?.filter(item => item.ManagerContact !== "--Please Select--")
    const [IsActivityDisable,setIsActivityDisable]=useState(false);
    useEffect(() => {
        document.title = `Investment Add`;
     },[]);
    useEffect(() => {
        dispatch(getCategory(1));
        dispatch(getManagerContacts());
        dispatch(getSubStrategy());
        dispatch(getPortfolioListAction());
        dispatch(getAllUsers());
        dispatch(getAssetLists());
        dispatch(getActivityEntityType(1));
        dispatch(getActivityType());
        
    }, []);

  
    const [selectedManager, setSelectedManager] = useState([]);
    const [assetId, SetAssetId] = useState([]);
    const [PortfolioId, SetPortfolioId] = useState([]);
    const [selectedActivityTypeId, SetselectedActivityTypeId] = useState([]);
    const [subject, setsubject] = useState();
    const [assetDDLlist, setAssetDDLlist] = useState(AssetListDDL);
    const [managerId, SetmanagerId] = useState([]);
    const [SubStrategyId, SetSubStrategyId] = useState([]);
    const [userId, SetuserId] = useState([]);
    const [ActivitycategorySubTypeIds, setActivitycategorySubTypeIds] = useState([]);
    const [PartnerLetter, SetPartnerLetter] = useState(false);
    const [ManagerLetter, SetManagerLetter] = useState(false);
    const [selectedEventDate, setSelectedEventDate] = useState(new Date());
    const [isFlagEnabled,SetIsFlagEnabled]=useState(true);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [showFiles, setshowFiles] = useState([]);
    const [resulttrim, setResulttrim] = useState();
    const [savingData,setSavingData]=useState(false);
    const [fileError, setFileError] = useState("");


    useEffect(() => {
        if(selectedFiles.length>0)
          SetIsFlagEnabled(false);
          else
          {
          SetIsFlagEnabled(true);
          SetPartnerLetter(false);
          SetManagerLetter(false);
          }
    },[selectedFiles])
    useEffect(() => {
        setAssetDDLlist(AssetListDDL);
        SetselectedActivityTypeId(SelectedActivity!=undefined?{
            ActivityTypeId: SelectedActivity[0]?.ActivityTypeId || '',
            ActivityType: SelectedActivity[0]?.ActivityType || ''
        }:"");
        setActivitycategorySubTypeIds(SelectedCategory!=undefined?{
            ActivitySubTypeId: SelectedCategory[0].ActivitySubTypeId || '',
            ActivitySubType: SelectedCategory[0].ActivitySubType || ''
        }:"")
        setIsActivityDisable(ActivityDisable);
        
    }, [AssetListDDL]);
    

    const ActivityTypeDDChange = (e) => {      
        SetselectedActivityTypeId({ ActivityTypeId: e.value.ActivityTypeId, ActivityType: e.value.ActivityType});
    }
    const commentsChange = (event) => { 
        setcomments(event.html);
    }

    const managerDropdownChange = (e) => {
       
        SetmanagerId([...e.value]);
        setSelectedManager({ ManagerContactId: e.value.ManagerContactId, ManagerContact:e.value.ManagerContact});
    };
    const subStrategyDropdownChange = (e) => {
        SetSubStrategyId([...e.value]);
       
    };
    const subjectChange = (event) => {
        
        setsubject(event.target.value);
        const result = SBATextBox(event.target.value)
        setResulttrim(result);
    }
    const CategoryDDChange = (e) => {
       
        setActivitycategorySubTypeIds({ ActivitySubTypeId: e.value.ActivitySubTypeId, ActivitySubType: e.value.ActivitySubType})
    
    };
    const CreatoronChange = (e) => {
       SetuserId([...e.value]);
        
    }
    const PortfolioChanged = (e) => {
        SetPortfolioId([...e.value]);
    };
    const AssetDDChanged = (e) => {
        
        SetAssetId([...e.value]);
    };
    const gridValueFormatter = (params) => {
        return params.value;
    };
    const eventDateChange = (newDate) => {
        setSelectedEventDate(newDate);
    }
  
    const allowedExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'png', 'jpeg'];

    const handleFileChange = (event) => {
        console.log(event.target.files,'123456')
        const newFiles = event.target.files;
        if (newFiles.length > 0) {
          const updatedFiles = [...selectedFiles];
          const startingRowIndex = updatedFiles.length; 
        
          for (let i = 0; i < newFiles.length; i++) {
            const file = newFiles[i];
            const fileName = file.name;
            const lastDotIndex = fileName.lastIndexOf('.');
            const extension = lastDotIndex >= 0 ? fileName.substring(lastDotIndex + 1) : '';
            // Check if the extension is allowed
            if (!allowedExtensions.includes(extension.toLowerCase())) {
                setFileError(`Unsupported file format: .${extension}`);
                continue; // Skip the rest if the format is invalid
            }
            setFileError("");
            const reader = new FileReader();
            reader.onload = function () {
              if (reader.result) {
                const arrayBuffer = reader.result;
                const base64String = arrayBufferToBase64(arrayBuffer);
                const rowIndex = startingRowIndex + i;        
                updatedFiles.push({ file, fileName, extension, base64String, rowIndex });
                setSelectedFiles(updatedFiles);
              }
            };
        
            reader.readAsArrayBuffer(file);
        if(updatedFiles.length>0)
        SetIsFlagEnabled(false);
          }
        }
        
    };

    const arrayBufferToBase64 = (arrayBuffer) => {
        const binary = [];
        const bytes = new Uint8Array(arrayBuffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary.push(String.fromCharCode(bytes[i]));
        }
        return btoa(binary.join(''));
    };

    const stateType = locationData.state !==null? locationData.state.Type === undefined ?null: locationData.state.Type:null;
    const stateNames = locationData.state !==null? locationData.state.Names === undefined ? null : locationData.state.Names:null;
    const stateActivity = locationData.state !==null? locationData.state.Activity === undefined ?null : locationData.state.Activity:null;
    const stateCategory = locationData.state !==null? locationData.state.Category === undefined ?null : locationData.state.Category:null;
    const stateSubject = locationData.state !==null? locationData.state.Subject === undefined ?null  : locationData.state.Subject:null;
    const stateCreator = locationData.state !==null? locationData.state.Creator === undefined ?null  : locationData.state.Creator:null;
    const cancelButtonClick = (e) => {
        history(`${UrlPath.DocumentsInvestment}`,{ state: { Type: stateType, Names: stateNames ,Activity:stateActivity,Category: stateCategory,Subject:stateSubject,Creator:stateCreator} });
    };
    const DeleteButtonRenderer = (props) => {
        const handleDeleteClick = () => {
            const updatedFiles = selectedFiles.filter((item, index) => item.rowIndex !== props.data.rowIndex);
            setSelectedFiles(updatedFiles);
            // Set display to none
            document.getElementById('fileInput').style.display = 'none';

            // Reset the file input value
            document.getElementById('fileInput').value = '';

            // Restore display
            document.getElementById('fileInput').style.display = 'block';
            // Force re-render if needed
        }
        return (
            <div className="actions-cell">
                <i
                    className="fas fa-trash"
                    style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                   onClick={handleDeleteClick}
                ></i>
            </div>
        );
    };

    const columnDefs = [
        {
            field: "fileName",
            headerName: "File Name",
            //cellRenderer: HyperlinkRenderer,
            sort: "asc",
            pinned: "left",
            minWidth: 442.47,
            filter: "agTextColumnFilter",
            valueFormatter: gridValueFormatter,
            tooltipField: 'FileName'
        },
        {
            headerName: "",
            field: "Delete",
            minWidth: 442.47,
            cellRenderer: DeleteButtonRenderer,
        }
    ];
    const defaultColDef = {
        sortable: true, filter: true, floatingFilter: true, flex: 1,  resizable: true,
    }
    const saveInvestment = (event) => {
 
        setSavingData(true);
        let saveSuccess = true;
        event.preventDefault();      
        const activityXRefs = [];
        if(!Modal)
        {
            if (assetId.length > 0) {
                activityXRefs.push(
                    ...assetId.map((asset) => ({
                        activityXRefId: 0,
                        activityId: 0,
                        activityEntityTypeId: 1,
                        activityEntityType: "Asset",
                        entityId: asset.AssetId,
                        entityName: asset.AssetName,
                    }))
                );
            }
    
            if (managerId.length > 0) {
                activityXRefs.push(
                    ...managerId.map((manager) => ({
                        activityXRefId: 0,
                        activityId: 0,
                        activityEntityTypeId: 2,
                        activityEntityType: "Manager",
                        entityId: manager.ManagerContactId,
                        entityName: manager.ManagerContact,
                    }))
                );
            }
    
            if (userId.length > 0) {
                activityXRefs.push(
                    ...userId.map((user) => ({
                        activityXRefId: 0,
                        activityId: 0,
                        activityEntityTypeId: 12,
                        activityEntityType: "User",
                        entityId: user.UserId,
                        entityName: user.Fullname,
                    }))
                );
            }
    
            if (SubStrategyId.length > 0) {
                activityXRefs.push(
                    ...SubStrategyId.map((SubStrategy) => ({
                        activityXRefId: 0,
                        activityId: 0,
                        activityEntityTypeId: 13,
                        activityEntityType: "SubStrategy",
                        entityId: SubStrategy.ClassificationId,
                        entityName: SubStrategy.ClassificationValue,
                    }))
                );
            }
    
            if (PortfolioId.length > 0) {
                activityXRefs.push(
                    ...PortfolioId.map((Portfolio) => ({
                        activityXRefId: 0,
                        activityId: 0,
                        activityEntityTypeId: 3,
                        activityEntityType: "Portfolio",
                        entityId: Portfolio.PortfolioId,
                        entityName: Portfolio.Name,
                    }))
                );
            }
        }
        else if (Modal)
        {
           
                activityXRefs.push(
                    {
                        activityXRefId: 0,
                        activityId: 0,
                        activityEntityTypeId: 1,
                        activityEntityType: "Asset",
                        entityId: selectedAsset.AssetId,
                        entityName: selectedAsset.AssetName,
                    });
            
                activityXRefs.push(
                   {
                        activityXRefId: 0,
                        activityId: 0,
                        activityEntityTypeId: 2,
                        activityEntityType: "Manager",
                        entityId: selectedAsset.ManagerContactId,
                        entityName: selectedAsset.ManagerContact,
                    }
                );
        }

       
        const data = { 
            "activitySummary": {
                "activityId": 0,
                "activityTypeId": selectedActivityTypeId.ActivityTypeId,
                "activitySubTypeId": ActivitycategorySubTypeIds.ActivitySubTypeId,
                "activityName": subject,
                "activityDescription": comments ? comments.replace(/<\/?[^>]+(>|$)/g, ""):null,
                "activityDescriptionHtml": comments ? comments:null,
                "activityDate": selectedEventDate,
                "activitySourceId": 1
            },
            "activityDetails":
            {
                "activityDetailId": 0,
                "activityId": 0,
                "emailMessageId": "",
                "emailFrom": "",
                "emailTo": "",
                "mailCc": "",
                "emailSubject":"" ,
                "emailBody": "",
                "emailBodyHtml": "",
                "emailDate": selectedEventDate,
                "meetingDate": selectedEventDate,
                "IsPartnerLetter": PartnerLetter,
                "IsManagerLetter": ManagerLetter
            },
            "activityXRefs": activityXRefs,
            "modifiedBy": 0,
        };
        const Documentdetails = (activityid) => {
            const DocumentData = selectedFiles.map((obj) => ({
                ActivityId: activityid,
                DocumentId: 0,
                DocumentName: obj.fileName,
                DocumentContent: obj.base64String,
                DocumentExtension: "."+obj.extension,
                DocumentDate: selectedEventDate,
                RuleId: 0,
                IsPartnerLetter: PartnerLetter,
                IsEmailForwarded: false,
                IsReturnsProcessed: false,
                IsManagerLetter: ManagerLetter,
                ModifiedBy: 0,
                ActivitySourceId: 1
            }));
           
                sbaAxios({
                    url: `${insertOrUpdateActivityDocument}`,
                    method: "post",
                    data: DocumentData,
                }).then((response) => {
                    setSavingData(false);
                    if (!Modal) {                      
                            toast.success("Investment Documents Saved Successfully", {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                                                 

                    }
                                  
                     
                })

                    .catch((error) => {
                        console.error(error);
                    setSavingData(false);

                    });

        }
        if (!selectedActivityTypeId.ActivityType) {
            SBNotify({ Msg: "Please Select Activity Type", type: "error" });
            saveSuccess = false;
            setSavingData(false);
        }       
        else if (!ActivitycategorySubTypeIds.ActivitySubTypeId || ActivitycategorySubTypeIds.ActivitySubTypeId === -1) {
            SBNotify({ Msg: "Please Select Category Type", type: "error" });
            saveSuccess = false;
            setSavingData(false);
        }
        else if ((resulttrim == false)||(!subject)) {
            SBNotify({ Msg: "Subject is Required", type: "error" });
            saveSuccess = false;
            setSavingData(false);
        }
        else if (assetId.length < 1 && !Modal) {
            SBNotify({ Msg: "Please Select Asset", type: "error" });
            saveSuccess = false;
            setSavingData(false);
        }

        // Documents are optional For all case 
        // if (selectedFiles.length < 1 && !Modal ) {
        //     SBNotify({ Msg: "Please Upload Document", type: "warning" });
        //     saveSuccess = false;
        // }
        

        if (saveSuccess) {

            sbaAxios({
                url: `${insertOrUpdateActivityDetails}`,
                method: "post",
                data: data,
            })
                .then((response) => {
                   
                    if (response > 0) {
                        if (selectedFiles.length > 0) {

                            Documentdetails(response)
                        
                        }
                        else if (Modal)
                        {
                           
                            if (selectedActivityTypeId.ActivityTypeId === 1) {

                                toast.success("Investment Note Saved Successfully", {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                            }

                            if (selectedActivityTypeId.ActivityTypeId === 2) {
                                
                                toast.success("Investment Document Saved Successfully", {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                            }
                           
                            
                        }

                        else
                        {
                            setTimeout(() => {
                            toast.success("Investment  Saved Successfully",
                                {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                              });
                            }, 500);   
                        }
                       
                            if (!Modal)
                                history(`${UrlPath.DocumentsInvestment}`,{ state: { Type: stateType, Names: stateNames ,Activity:stateActivity,Category: stateCategory,Subject:stateSubject,Creator:stateCreator} }, {

                                });
                            else if (Modal) {
                                
                                dispatch(getAssetNotesTabDetails(selectedAsset.AssetId));
                                dispatch(getAssetDocuments(selectedAsset.AssetId));                             
                                afterSave(selectedActivityTypeId.ActivityType);
                                setDrawerSet(false);
                            }

                                                                                                        
                  
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setSavingData(false);
                });
        };
    }

    return <>{savingData ? <><LoadingScreen/></> : <div className="container-fluid" >
                <div style={Modal ? { marginTop: "-25px" } : {}}>

                    <div className="d-flex justify-content-end gap-2">
                        {!Modal && <button type="submit" className="s-sm-btn me-1" onClick={cancelButtonClick} > Cancel</button>}
                <button type="submit" className="p-sm-btn mx-1" disabled={savingData} onClick={saveInvestment}>Save </button>
                        {/*<button type="submit" className="p-sm-btn mx-1" > Save & Email</button>*/}


                    </div>
                    <br />
                    <div>
                        <div >
                            <div className="row-md-12 d-flex gap-1">
                                <div className={Modal ? `col-md-12` : `col-md-6`}>
                                    <div class="row detail p-3  m-0">

                                        <div className="row">

                                            <div className="col-md-4">
                                                <label
                                                    for="select fund"
                                                    className="mb-1 ms-2 fw-semibold fs-12"
                                                >
                                                    Activity Type
                                                    <span className="mandatory">*</span>

                                                </label>
                                                <div>
                                                    <SBADropDown
                                                        className="w-85"
                                                        data={ActivityType}
                                                        value={selectedActivityTypeId}
                                                        valueField="ActivityTypeId"
                                                        textField="ActivityType"
                                                        onChange={ActivityTypeDDChange}
                                                        filterable={true}
                                                        popupSettings={{ className: Modal ? `modalDD` : `` }}
                                                        disabled={IsActivityDisable}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <label
                                                    for="select fund"
                                                    className="mb-1 ms-2 fw-semibold fs-12"
                                                >
                                                    Category <span className="mandatory">*</span>
                                                </label>
                                                <div>

                                                    <SBADropDown
                                                        className="w-85"
                                                        textField={"ActivitySubType"}
                                                        valueField={"ActivitySubTypeId"}
                                                        data={Category}
                                                        value={ActivitycategorySubTypeIds}
                                                        onChange={CategoryDDChange}
                                                        filterable={true}
                                                        popupSettings={{ className: Modal ? `modalDD` : `` }}
                                                    />
                                                </div>

                                            </div>
                                            <div className="col-md-4">
                                                <label
                                                    for="select fund"
                                                    className="mb-1 ms-2 fw-semibold fs-12"
                                                >
                                                    Event Date
                                                </label>
                                         <div>
                                                <SBDatePicker className="w-75" id="eventDate"
                                                    defaultValue={selectedEventDate ? moment(selectedEventDate)
                                                        : null}
                                                    onChange={eventDateChange}>
                                                </SBDatePicker>
                                            </div>
                                     </div>

                                        </div>
                                        <div className="row" style={{ marginTop: "20px" }}>
                                            <div className="col-md-6">
                                                <label
                                                    for="select fund"
                                                    className="mb-1 ms-2 fs-12 fw-semibold"
                                                >
                                                    Subject <span className="mandatory">*</span>
                                                </label>
                                                <input
                                                    className="w-125 input-default form-control"
                                                    type="text"
                                                    placeholder="Type here"
                                                    onChange={subjectChange}
                                                    Value={subject}
                                                //onKeyUp={loadOnEnter}
                                                />

                                            </div>
                                            {(!Modal || ShowDocuments || Modal === 'undefined' || ShowDocuments === 'undefined') && (

                                                <div className="col-md-3">
                                                    <label></label>
                                                    <label style={{ display: 'flex', alignItems: 'center' }}>
                                                        <input
                                                            className="me-1"
                                                            type="checkbox"
                                                            checked={PartnerLetter}
                                                            disabled={isFlagEnabled}
                                                            onChange={(e) => { SetPartnerLetter(value => !value) }}
                                                        />
                                                        <span>Partner Letter</span>
                                                    </label>
                                                </div>
                                            )
                                            }
                                            {(!Modal || ShowDocuments || Modal === 'undefined' || ShowDocuments === 'undefined') && (
                                                <div className="col-md-3">
                                                    <label></label>
                                                    <label style={{ display: 'flex', alignItems: 'center' }}>
                                                        <input className="me-1"
                                                            type="checkbox"
                                                            disabled={isFlagEnabled}
                                                            checked={ManagerLetter}
                                                            onChange={(e) => { SetManagerLetter(value => !value) }}
                                                        />
                                                        <span >Manager Letter</span>
                                                    </label>
                                                </div>
                                            )}

                                        </div>
                                        <div className="row" style={{ marginTop: "10px" }}>
                                            <label
                                                for="select fund"
                                                className="mb-1 ms-2 fs-12 fw-semibold">
                                                Description:
                                            </label>
                                            <SBAEditor id="editor" onChange={commentsChange} defaultContent={comments} editorHeight={300} setContent={setcomments} />

                                        </div>
                                        {!Modal && (
                                            <div className="row" style={{ marginTop: "10px" }}>
                                                <div>
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fs-12 fw-semibold"
                                                    >
                                                        Tags:
                                                    </label>
                                                    <input
                                                        className="w-400 input-default form-control"
                                                        type="text"

                                                        //onChange={subjectChange}
                                                        Value={''}
                                                        //onKeyUp={loadOnEnter}
                                                        style={{ height: '60px' }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <div className="row" style={{ marginTop: "10px" }}>
                                            <div style={{ position: "relative" }}>
                                                <input
                                                    type="file"
                                                    id="fileInput"
                                                    className="input-hidden"
                                                    onChange={handleFileChange}
                                                />
                                                {fileError && <p style={{ color: 'red' }}>{fileError}</p>}
                                            </div>
                                        </div>

                                        <div className="row" style={{ marginTop: "10px" }}>

                                            <div className="ag-theme-alpine" style={{ width: '100%', height: '300px' }}>
                                                <AgGridReact
                                                    columnDefs={columnDefs}
                                                    rowData={selectedFiles}
                                                    defaultColDef={defaultColDef}
                                                    // domLayout= {'autoHeight'}
                                                    overlayNoRowsTemplate={`<span>${'No data Available'}</span>`}
                                                >
                                                </AgGridReact>
                                            </div>
                                        </div>


                                    </div>

                                </div>
                                {!Modal && <div className="col-md-6">

                                    <div class="row detail p-3 m-0">

                                        <div className="row">

                                            <div className="col-md-12">
                                                <label className="mb-1 ms-2 fw-semibold fs-12">
                                                    Manager
                                                </label>
                                                <div className="col-lg-12 mb-4">
                                                    <SBAMultiSelectCheck
                                                        className="w-75"
                                                        data={manager}
                                                        dataItemKey="ManagerContactId"
                                                        textField="ManagerContact"
                                                        onChange={managerDropdownChange}
                                                        value={managerId}
                                                        tags={
                                                            managerId.length > 0
                                                                ? [
                                                                    {
                                                                        text: `${managerId.length} items selected`,
                                                                        data: [...managerId],
                                                                    },
                                                                ]
                                                                : []
                                                        }
                                                        filterable={true}
                                                    ></SBAMultiSelectCheck>
                                                </div>


                                            </div>
                                        </div>

                                        <div className="row" >

                                            <div className="col-md-12">
                                                <label
                                                    for="select fund"
                                                    className="mb-1 ms-2 fw-semibold fs-12"
                                                >
                                                    Asset
                                                </label>
                                                <div className="col-lg-12 mb-4">
                                                    <SBAMultiSelectCheck
                                                        data={assetDDLlist}
                                                        dataItemKey="AssetId"
                                                        textField="AssetName"
                                                        className="w-75"
                                                        onChange={AssetDDChanged}
                                                        value={assetId}
                                                        tags={
                                                            assetId.length > 0
                                                                ? [
                                                                    {
                                                                        text: `${assetId.length} items selected`,
                                                                        data: [...assetId],
                                                                    },
                                                                ]
                                                                : []
                                                        }
                                                        filterable={true}
                                                    ></SBAMultiSelectCheck>
                                                </div>


                                            </div>
                                        </div>

                                        <div className="row gap-3">

                                            <div className="col-md-12">
                                                <label
                                                    for="select fund"
                                                    className="mb-1 ms-2 fw-semibold fs-12"
                                                >
                                                    Strategy
                                                </label>
                                                <div className="col-lg-12 mb-4">
                                                    <SBAMultiSelectCheck
                                                        className="w-75"
                                                        data={SubStrategy}
                                                        value={SubStrategyId}
                                                        tags={
                                                            SubStrategyId.length > 0
                                                                ? [
                                                                    {
                                                                        text: `${SubStrategyId.length} items selected`,
                                                                        data: [...SubStrategyId],
                                                                    },
                                                                ]
                                                                : []
                                                        }
                                                        textField={"ClassificationValue"}
                                                        dataItemKey={"ClassificationId"}
                                                        onChange={subStrategyDropdownChange}
                                                        filterable={true}
                                                    />

                                                </div>


                                            </div>
                                        </div>
                                        <div className="row gap-3">

                                            <div className="col-md-12">
                                                <label
                                                    for="select fund"
                                                    className="mb-1 ms-2 fw-semibold fs-12"
                                                >
                                                    Contributor
                                                </label>
                                                <div className="col-lg-12 mb-4">
                                                    <SBAMultiSelectCheck
                                                        className="w-75"
                                                        data={users}
                                                        value={userId}
                                                        tags={
                                                            userId.length > 0
                                                                ? [
                                                                    {
                                                                        text: `${userId.length} items selected`,
                                                                        data: [...userId],
                                                                    },
                                                                ]
                                                                : []
                                                        }
                                                        dataItemKey="UserId"
                                                        textField="Fullname"
                                                        onChange={CreatoronChange}
                                                        filterable={true}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                        <div className="row gap-3">

                                            <div className="col-md-12">
                                                <label
                                                    for="select fund"
                                                    className="mb-1 ms-2 fw-semibold fs-12"
                                                >
                                                    Portfolio
                                                </label>
                                                <div className="col-lg-12 mb-4">
                                                    <SBAMultiSelectCheck
                                                        className="w-75"
                                                        data={getPortfolioList}
                                                        value={PortfolioId}
                                                        tags={
                                                            PortfolioId.length > 0
                                                                ? [
                                                                    {
                                                                        text: `${PortfolioId.length} items selected`,
                                                                        data: [...PortfolioId],
                                                                    },
                                                                ]
                                                                : []
                                                        }
                                                        filterable={true}
                                                        dataItemKey="PortfolioId"
                                                        textField="Name"
                                                        onChange={PortfolioChanged}

                                                    />

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer></ToastContainer>
            </div>
}</>
};

